module.exports = __webpack_public_path__ + "img/166.02e29802.jpg";